// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".passwordInput_passwordInput__WFa29 {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.passwordInput_icon___sNPS {\n  position: absolute;\n  right: 10px;\n}\n.passwordInput_icon___sNPS svg {\n  cursor: pointer;\n  width: 1rem;\n  height: 1rem;\n  fill: var(--black);\n}\n.passwordInput_icon___sNPS svg:hover {\n  fill: var(--text-primary);\n}", ""]);
// Exports
exports.locals = {
	"passwordInput": "passwordInput_passwordInput__WFa29",
	"icon": "passwordInput_icon___sNPS"
};
module.exports = exports;
